<template>
  <div v-drag  ref="dragWrap">
    <a-modal  
             v-model:visible="dialogVisible"
             @ok="search"
             :get-container="() => dragWrap"
              :closable="false"
             width="480rem">
              
                   <template #title>
      <span style="font-size: 24rem;font-weight: 600">导出</span>
    </template>
      <a-row class="input_Warp">
        <div class="text">
<a-checkbox
    :checked="exportType === '0'"
    @change="exportType = '0'">
    只导出题目
  </a-checkbox>
  <a-radio-group v-model:value="radioValue" v-if="exportType === '0'">
            <a-radio :value="0">只导出原题</a-radio>
          <a-radio :value="1">导出原题加推送题 </a-radio>
          
        </a-radio-group>
        </div>
         <div class="text" style="margin-top: 24rem;"> 
  <a-checkbox
   
    :checked="exportType === '1'"
    @change="exportType = '1'">
    导出题目、题目答案及解析
  </a-checkbox>
    <a-radio-group v-model:value="radioValue" v-if="exportType === '1'">
            <a-radio :value="0">只导出原题</a-radio>
          <a-radio :value="1">导出原题加推送题 </a-radio>
          
        </a-radio-group>
      </div>
      </a-row>
      <!-- <a-row class="input_Warp">
        <div style="width:80rem;font-size:18rem">题型</div>
        <a-select style="flex:1"
                  v-model:value="question_type_id"
                  placeholder="请选择"
                  allowClear
                  :options='typeList.map(item=>({label:item.question_type_name,value:item.question_type_id}))'>
        </a-select>
      </a-row> -->

      <template #footer>
        <div class="btn_warp">
          <div @click="handleClose">取消</div>
          <div @click="search">导出</div>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<script setup>

import { ref, toRefs, defineExpose } from "vue"
import { collectTagList } from "@/api/collect.js"
import { errorTopicType } from '@/api/errorBook.js'
const dragWrap = ref(null)
let dialogVisible = ref(false)
let keywords = ref('')
let radioValue = ref(1)
let checked = ref(false)
let checked1 = ref(false)
let question_type_id = ref(undefined)
let typeList = ref([])
let subject_id = ref('')
let exportType = ref('0')
const emit = defineEmits(['exportData'])
const handleClose = () => {
  dialogVisible.value = false
  question_type_id.value = undefined
  keywords.value = ''
}
const search = () => {

  emit('exportData', exportType.value,radioValue.value)
  handleClose()
}

const getTypeList = async () => {
  const { data } = await errorTopicType({
    subject_id: subject_id.value
  })
  typeList.value = data.list
}


defineExpose({
  getTypeList,
  subject_id,
  dialogVisible,
  keywords,
})

</script>

<style lang="scss" scoped>
.text_warp {
  word-break: break-all;
  font-weight: 500;
  color: #666666 !important;
  line-height: 23px;
  font-size: 16px;
  padding: 27px;
  padding-top: 0;
}
 
:deep .ant-modal-content {
border-radius:32rem ;
}
:deep .ant-modal {
top: 35%;
}
:deep .ant-input-affix-wrapper > input.ant-input {
  font-size: 18rem;
}
:deep .ant-checkbox-wrapper {
    font-size: 20rem;
}
:deep .ant-radio-wrapper{
   font-size: 20rem;
   margin-right:24rem
}
:deep .ant-checkbox-inner{
  width: 22rem;
  height: 22rem;
}
:deep .ant-radio-inner{
  width: 22rem;
  height: 22rem;
}

:deep .ant-radio-group{
  // display: flex;
  // flex-direction: column;
  // margin-top: 24rem;
  // margin-bottom: 24rem;
  margin-left: 16rem;
}
:deep .ant-modal-body{
  padding: 32rem;
}
.btn_warp {
  // border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  // margin-bottom: -30rem;
   ;
  div {
    flex: 1;
    font-weight: 400;
    font-size: 24rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:nth-child(2) {
      color: #2196f3;
      border-left: 1px solid #e5e5e5;
      height: 100%;
    }
  }
}

.input_Warp {
     display: flex;
    justify-content: center;
    margin-left: 8rem;
    margin-bottom: 24rem;
    flex-direction: column;
    gap: 24rem;
    // align-content: center;
    .text{
          display: flex;
    gap: 24rem;
    flex-direction: column;
    // align-items: baseline;
    align-content: center;
    justify-content: center;
    }
  span {
    flex: 1;
  }
}
</style>